import { Component, OnInit } from '@angular/core';
import { ConfigService } from './_services/config.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor() {
    // console.log('LTax4 verison',configService.config.version);
  }

}
